import React, { useRef, useEffect, useState } from 'react';

// Rewrite CSS element selectors that can't match inside Shadow DOM.
// The copied HTML is a fragment — it has no <html>, <body>, or :root elements.
// Without rewriting, any rule targeting these (e.g. `body { font-size: ... }`)
// silently fails, causing inherited styles like font-size, letter-spacing,
// border-radius etc. to be missing from child elements.
function rewriteCssForShadowDom(css) {
  const selectorBoundary = /(?=[\s{.[:,>+~#)])/;
  const before = /(^|[\s,}>+~])/;

  return css
    .replace(new RegExp(before.source + ':root' + selectorBoundary.source, 'gm'), '.flora-root')
    .replace(new RegExp(before.source + 'html' + selectorBoundary.source, 'gm'), '.flora-root')
    .replace(new RegExp(before.source + 'body' + selectorBoundary.source, 'gm'), '.fusion-body');
}

const FlooraSearchPage = () => {
  const hostRef = useRef(null);
  const shadowRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hostRef.current || shadowRef.current) return;

    shadowRef.current = hostRef.current.attachShadow({ mode: 'open' });

    Promise.all([
      fetch('/static/FlooraSearchPage/searchPage.html').then(r => r.text()),
      fetch('/static/FlooraSearchPage/profilePage.css').then(r => r.text()),
    ])
      .then(([html, css]) => {
        const style = document.createElement('style');
        style.textContent = rewriteCssForShadowDom(css);
        shadowRef.current.appendChild(style);

        // Recreate the ancestor structure the original page had:
        // <html>/:root → .flora-root  (for :root and html element selectors)
        // <body>       → .fusion-body (for body element selectors + body class selectors)
        // #wrapper     → #wrapper     (86 CSS selectors depend on it)
        // #main        → #main        (77 CSS selectors depend on it)
        const root = document.createElement('div');
        root.className = 'flora-root';

        const bodyEl = document.createElement('div');
        bodyEl.className = 'fusion-body';

        const wrapper = document.createElement('div');
        wrapper.id = 'wrapper';

        const main = document.createElement('div');
        main.id = 'main';
        main.innerHTML = html;

        wrapper.appendChild(main);
        bodyEl.appendChild(wrapper);
        root.appendChild(bodyEl);
        shadowRef.current.appendChild(root);
      })
      .catch(err => setError(err.message));
  }, []);

  if (error) return <div>Failed to load content: {error}</div>;

  return <div ref={hostRef} />;
};

export default FlooraSearchPage;
